/**
 * The two scheduled imports behind the supplier portal.
 *
 * A supplier's submission reaches the shop through two jobs: the PIM import,
 * which writes the product, and the price import, which writes its prices. They
 * are not scoped to a supplier — one run covers everyone who has published — so
 * these calls take no supplier, and the screen shows them once.
 */
define('entities/suppliers/portal_imports',[
  'app',
  'jquery',
  'settings'
], function (
  App,
  $,
  Settings
) {
  'use strict';

  var API = {

    getJobs: function () {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/portalImports')
      });
    },

    /**
     * Asks the scheduler to run one now. `key` is 'price' or 'pim'.
     *
     * Answers as soon as the run is accepted, not when the import is done — the
     * import takes minutes, so the screen says "started", never "finished".
     */
    runJob: function (key) {
      return $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'v2/portalImports/' + key + '/run')
      });
    }
  };

  App.reqres.setHandler('portal-imports:get', function () {
    return API.getJobs();
  });

  App.reqres.setHandler('portal-imports:run', function (key) {
    return API.runJob(key);
  });
});

